var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "user_prof d-flex flex-column" }, [
    _vm.user.guest == 0
      ? _c("div", { staticClass: "mb-3" }, [
          _c(
            "button",
            {
              staticClass:
                "btn btn-outline-success btn-lg btn-block waves-effect waves-themed",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.go_profile.apply(null, arguments)
                },
              },
            },
            [_vm._v("\n\t\t\t" + _vm._s(_vm.__t("USER_PROFILE")) + "\n\t\t")]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "mb-3" }, [
      _c(
        "button",
        {
          staticClass:
            "btn btn-outline-danger btn-lg btn-block waves-effect waves-themed",
          attrs: { type: "submit" },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.logout.apply(null, arguments)
            },
          },
        },
        [_vm._v("\n\t\t\t" + _vm._s(_vm.__t("USER_EXIT")) + "\n\t\t")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }